import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule,LOCALE_ID,TRANSLATIONS, TRANSLATIONS_FORMAT } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_BASE_HREF, LocationStrategy } from '@angular/common';

import { TabsModule, ModalModule } from 'ngx-bootstrap';
import { FullCalendarModule } from 'ng-fullcalendar';

// NG Translate
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { I18n } from '@ngx-translate/i18n-polyfill';

// modules (login and sessionOut modules are the features not lazy loaded)
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
//New login Module
import { NewLoginModule} from  './new-login/new-login.module';
import { LoginModule } from './login/login.module';
import { NewAccountRecoveryModule } from 'app/new-account-recovery/new-account-recovery.module';
import { NewRegistrationModule } from 'app/new-registration/new-registration.module';
import { NewLoginWidgetModule } from './new-login-widget/new-login-widget.module';


// import { SessionOutModule } from './session-out/session-out.module';
// import { OutageModule } from './outage/outage.module';

// components
import { AppComponent } from './app.component';
// import { SessionOutNativeComponent } from './session-out/session-out-native/session-out-native.component';

// routing
import { AppRoutingModule } from './app-routing.module';
import { AppLocationStrategy } from './app-location-strategy.service';

// authentication
import { AuthModule } from './auth/auth.module';
// import { LifeeventModule } from './shared/enrollment/lifeevent/lifeevent.module';
// import { WellnessAuthorizationModule } from './wellness-authorization/wellness-authorization.module'

// services
import { CFHttpClient } from './shared/cf-http-client';
// import { SsoService } from './sso/sso.service';
import { NativeIntegrationService } from './shared/native-integration.service';
// import { OutageService } from 'app/outage/outage.service';
import { TestHttpInterceptor } from './interceptor';
// import { SessionOutComponent } from 'app/session-out/session-out.component';
// import { ChangeImageComponent } from 'app/my-profile/security-information/change-image/change-image.component';
import { getBaseLocation } from './app-common-functions';
import { OktaLoginComponent } from './okta-login/okta-login.component';

// import { PagecontentModule } from './pagecontent/pagecontent.module';
// import { MyProfileModule } from 'app/my-profile/my-profile.module';
// import { FapWrapperService } from './fap-wrapper/fap-wrapper.service';
// import { SdWrapperService } from './sd-wrapper/sd-wrapper.service';

// import { FapWrapperPublicService } from './fap-wrapper/fap-wrapper-public.service';
//import { LifeEventService } from './shared/enrollment/lifeevent/lifeevent-service';
// import { UserSession } from './shared/enrollment/shared/user-session.service';
// import { UserSession as alias } from './shared/user-session';
// import {BaseAppService} from './shared/enrollment/shared/baseapp.service';
// import { GlobalErrorHandler } from 'app/shared/frontend-error-logging/global.error.handler.service';
// import { GlobalLoggingService } from 'app/shared/frontend-error-logging/global.logging.service';
// import { OnlineChatService } from 'app/shared/online-chat/online-chat.service';
// import { YesRedirectComponent } from './yes-redirect/yes-redirect.component';


declare const require; 




export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, OktaLoginComponent],
  imports: [
   
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    //NewAccountRecoveryModule,
    //NewLoginModule,
    NewLoginWidgetModule,
  // NewRegistrationModule,
   // LoginModule, //revert  commente code if newlogin route not worked
    AppRoutingModule,//
    AuthModule,
    SharedModule.forRoot(),
    CoreModule,
    // OutageModule,
    // SessionOutModule,
    // PagecontentModule,
    // MyProfileModule,
    //LifeeventModule,
    FullCalendarModule,
   
  ],
  providers: [
    CFHttpClient,
    // SsoService,
    // OutageService,
  
    NativeIntegrationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TestHttpInterceptor,
      multi: true
    },
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseLocation
    },
    {
      provide: LocationStrategy,
      useClass: AppLocationStrategy
    },
    {
      provide: TRANSLATIONS_FORMAT, 
      useValue: "xlf"
    },    
    {
      provide: TRANSLATIONS,
      useFactory: (locale) => {
//        locale = locale || 'en'; // default to english if no locale provided
        locale = 'en';
//        return require(`raw-loader!../assets/locale/messages.${locale}.xlf`);
        return '<xml></xml>';
      },
      deps: [LOCALE_ID]
    },
    I18n,
    // FapWrapperService,
    // SdWrapperService,
    // FapWrapperPublicService,
    // UserSession,
    // BaseAppService,
    // GlobalErrorHandler,
    // GlobalLoggingService,
    // OnlineChatService
  ],
  entryComponents: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts